import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import ResizeListener from "../../../../utility/ResizeListener";

import { CustomButton } from "../../../components/customButton/CustomButton";
import { CustomInput } from "../../../components/customInput/CustomInput";
import CustomDatePicker from "../../../components/custom_date_picker";
import { BlackClear } from "../../../resources/assetsManager";
import { BG_COLOR, WHITE_COLOR } from "../../../resources/colorsManager";
import {
  schedulerDropdown,
  schedulerTypeDropdown1,
} from "../../../resources/dropdownData";

function AddScheduleBody({ onClose, onSuccess }) {
  const [scheduleName, setScheduleName] = useState("");
  const [email, setEmail] = useState("");
  const [frequency, setFrequency] = useState("");
  const [type, setType] = useState("");
  const [date, setDate] = useState("");
  const [disabled, setDisabled] = useState(true);
  const { width } = ResizeListener();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const inputStyle = {
    backgroundColor: BG_COLOR,
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
  };
  useEffect(() => {
    if (
      scheduleName !== "" &&
      email !== "" &&
      frequency !== "" &&
      type !== "" &&
      date !== ""
    ) {
      setDisabled(false);
    } else setDisabled(true);
  }, [scheduleName, email, frequency, type, date]);

  const onClickAddSchedule = () => {
    setLoading(true);
    ApiRequestPost.addScheduler({
      emailId: email,
      frequency: frequency,
      schedulerName: scheduleName,
      startDate: date,
      type: type,
    })
      .then((res) => {
        if (res.responseCode === "OK") {
          enqueueSnackbar(res?.responseMessage, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(res?.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err?.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 35px",
        backgroundColor: WHITE_COLOR,
        minWidth: 300,
        minHeight: 400,
        borderRadius: 7,
        width: width * 0.28,
        // alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
          }}
        >
          Add Schedule
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: BG_COLOR,
            padding: 10,
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img src={BlackClear} />
        </div>
      </div>
      <CustomInput
        value={scheduleName}
        onChange={(data) => setScheduleName(data)}
        inputStyles={{ ...inputStyle }}
        placeholder="Scheduler Name"
        type="input"
        validator="name"
      />
      <CustomInput
        value={email}
        onChange={(data) => setEmail(data)}
        inputStyles={{ ...inputStyle }}
        placeholder="Email ID"
        type="input"
        validator="email"
      />
      <CustomDatePicker
        onChangeDate={(date) => {
          setDate(date);
        }}
        datePlaceholder="Date"
        style={{
          backgroundColor: BG_COLOR,
        }}
        fontStyles={{
          marginLeft: 10,
        }}
      />
      <CustomInput
        options={schedulerDropdown}
        value={frequency}
        onChange={(data) => setFrequency(data)}
        type="select"
        inputStyles={{
          backgroundColor: BG_COLOR,
          height: 50,
          width: "100%",
          borderRadius: 5,
          padding: 0,
          margin: 0,
          maxWidth: "100%",
          minWidth: 100,
          paddingLeft: 20,
        }}
        dropdownStyle={{
          width: "100%",
          padding: 0,
          margin: 0,
        }}
      />
      <CustomInput
        options={schedulerTypeDropdown1}
        value={type}
        onChange={(data) => setType(data)}
        type="select"
        inputStyles={{
          backgroundColor: BG_COLOR,
          height: 50,
          width: "100%",
          borderRadius: 5,
          padding: 0,
          margin: 0,
          maxWidth: "100%",
          minWidth: 100,
          paddingLeft: 20,
        }}
        dropdownStyle={{
          width: "100%",
          padding: 0,
          margin: 0,
          marginTop: 15,
        }}
      />
      <CustomButton
        title="Add"
        styles={{
          marginTop: 20,
          marginBottom: 10,
          width: "100%",
          borderRadius: 4,
        }}
        textStyle={{
          color: WHITE_COLOR,
        }}
        onClick={() => {
          onClickAddSchedule();
        }}
        disabled={disabled}
        loading={loading}
      />
    </div>
  );
}

export default AddScheduleBody;
